var React = require('react');

function Ln (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.7788 0H2.03157C1.13352 0 0.407349 0.708984 0.407349 1.58555V20.4102C0.407349 21.2867 1.13352 22 2.03157 22H20.7788C21.6769 22 22.4073 21.2867 22.4073 20.4145V1.58555C22.4073 0.708984 21.6769 0 20.7788 0ZM6.9343 18.7473H3.66868V8.2457H6.9343V18.7473ZM5.30149 6.81484C4.25305 6.81484 3.40657 5.96836 3.40657 4.92422C3.40657 3.88008 4.25305 3.03359 5.30149 3.03359C6.34563 3.03359 7.19211 3.88008 7.19211 4.92422C7.19211 5.96406 6.34563 6.81484 5.30149 6.81484ZM19.1546 18.7473H15.8933V13.6426C15.8933 12.4266 15.8718 10.8582 14.196 10.8582C12.4988 10.8582 12.2409 12.1859 12.2409 13.5566V18.7473H8.98391V8.2457H12.112V9.68086H12.155C12.589 8.85586 13.6546 7.98359 15.2402 7.98359C18.5445 7.98359 19.1546 10.1578 19.1546 12.9852V18.7473Z","fill":"white"}));
}

Ln.defaultProps = {"width":"23","height":"22","viewBox":"0 0 23 22","fill":"none"};

module.exports = Ln;

Ln.default = Ln;
